import React, { useState, useEffect } from 'react';
import { Link } from '@routes'
import * as G from '@styles/MobileNav.styled'
import IconEmail from '@icons/Email'
import IconAppraisal from '@icons/Appraisal'
import IconAccount from '@icons/Account'
import { getCookie } from '@cookies'
import { useEnquiryFormContext } from '@context/EnquiryFormContext'
import IconMobile from '@icons/Mobile'

const OfficeMobileNavBarBottom = ({phone, officeSlug, active = false}) => {
  const { setShowEnquiryForm } = useEnquiryFormContext()
  const token = getCookie('token')
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <G.MobileNav justifyBetween={!!phone} scrolled={scrolled}>
      <G.MobileNavItem onClick={() => setShowEnquiryForm(true)}>
        <IconEmail />
        Enquire
      </G.MobileNavItem>
      {phone && (
        <a href={`tel:${phone}`}>
          <G.MobileNavItem>
            <IconMobile />
            Call
          </G.MobileNavItem>
        </a>
      )}
      <Link route={`/request-an-appraisal/${officeSlug}`} passHref>
        <G.MobileNavItem>
          <IconAppraisal />
          Appraisal
        </G.MobileNavItem>
      </Link>
      <Link route={token ? '/my-account' : '/login'}>
        <G.MobileNavItem>
          <IconAccount />
          Account
        </G.MobileNavItem>
      </Link>
    </G.MobileNav>
  )
}

export default OfficeMobileNavBarBottom
